export default (Alpine) => {

	Alpine.directive('site-message', (el) => {

		const $el = $(el);

		let icon = 'check-circle';

		if ($el.hasClass('warning') === true)  {
			
			icon = 'exclamation-circle';

		} else if ($el.hasClass('notice') === true)  {
			
			icon = 'info-circle';

		} else if ($el.hasClass('error') === true) {
			
			icon = 'emoji-frown';

		}

		$el.prepend(`<span class="bi bi-${icon}"></span> `);

		if (!$el.hasClass('unclosable')) {

			$el.append('<a class="bi bi-x close"></a>')
			   .find('a.close')
			   .on('click', () => $el.remove());

		}
		
	});

};